import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5775a834"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-wrapper-inner columns is-gapless" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"column login-column is-8 h-hidden-mobile h-hidden-tablet-p hero-banner\" data-v-5775a834><div class=\"hero login-hero is-fullheight is-app-grey\" data-v-5775a834><div class=\"hero-body\" data-v-5775a834><div style=\"display:block;margin:auto;\" data-v-5775a834><img src=\"/images/hp-jbdh.jpeg\" alt=\"Banner\" data-v-5775a834></div></div><div class=\"hero-footer\" data-v-5775a834><p class=\"has-text-centered\" data-v-5775a834></p></div></div></div>", 1)
const _hoisted_3 = { class: "column is-4" }
const _hoisted_4 = { class: "hero is-fullheight is-white" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hero-heading" }, null, -1))
const _hoisted_6 = { class: "hero-body" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "columns" }
const _hoisted_9 = { class: "column is-12" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-content" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Welcome Back."),
  /*#__PURE__*/_createElementVNode("p", null, "Please sign in to your account")
], -1))
const _hoisted_11 = { class: "auth-form-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_LoginForm)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}